<template>
  <GridBase green-energy>
    <h2 v-if="kr">
      <span>자연을 지키는 기술과 <br />사람을 돌보는 에너지</span>
    </h2>
    <h2 v-else><TextBlock file="green/green-energy-t1" class="pre-line" /></h2>
    <grid-base alpha50 class="sec1">
      <TextBlock file="green/green-energy-t1" class="pre-line" v-if="kr" />
      <TextBlock file="green/green-energy-t1-1" class="pre-line" v-else />
    </grid-base>
    <section class="sec2">
      <div class="image-wrap">
        <div class="graph-img"></div>
      </div>
      <div class="inner-wrap">
        <h3 v-if="kr"><TextBlock file="green/green-energy-t3" class="pre-line" /></h3>
        <h3 v-else><TextBlock file="green/green-energy-t3" class="pre-line" /></h3>
        <p v-if="kr">
          저탄소, 저전력 인프라에 대한 패러다임이 확대되고 사업장 및 주요 설비 운영의 환경영향 최소화가 요구되고
          있습니다. 데이터센터 각은 태양광, 지열 에너지 등 다양한 친환경 설비를 도입하여 에너지 소모와 비용을 절감하고,
          에너지 효율(PUE)을 지속적으로 관리합니다.
        </p>
        <p v-else>
          We see regulations on low-carbon and low-power infrastructures are expanding, along with the rise of demands
          for minimal impact on the environment from the operation of business places and major facilities. DATA CENTER
          GAK has adopted various eco-friendly facilities, such as solar power and geothermal energy, reducing energy
          consumption and costs as well as continuously managing power usage effectiveness (PUE).
        </p>
      </div>
      <div class="inner-wrap">
        <h4>Go To Green</h4>
        <div class="split-view">
          <h3 v-if="kr"><TextBlock file="green/green-energy-t2" class="pre-line" /></h3>
          <h3 v-else><TextBlock file="green/green-energy-t2" class="pre-line" /></h3>
          <div>
            <div v-if="kr">
              <div class="txt">
                <p>온실가스 배출 감축량</p>
                <p><b>1.5</b><s>만 톤</s></p>
              </div>
              <div class="txt">
                <p>묘목을 심는 효과</p>
                <p class="tr"><b data-num="0, 225">225</b><b class="eq">=</b><s>만 그루</s></p>
              </div>
            </div>
            <div v-else>
              <div class="txt">
                <p>Reduced amount of <br />greenhouse gas emissions</p>
                <p><b>15</b><s>thousand tons</s></p>
              </div>
              <div class="txt">
                <p>Effects of planting trees</p>
                <p class="tr">
                  <b data-num="0, 2.25">2.25</b><b class="eq">=</b
                  ><s
                    >million<br />
                    trees</s
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="graph">
        <p v-if="kr">온실가스 배출량 대비 감소분 (tCO2)</p>
        <p v-else>Reduction compared to <br />greenhouse emissions (tCO2)</p>
        <Graph :info="greengas" />
        <div class="desc" v-if="kr">
          <p>각 춘천</p>
          <p>각 세종</p>
        </div>
        <div class="desc" v-else>
          <p>GAK Chuncheon</p>
          <p>GAK Sejong</p>
        </div>
      </div>
      <div class="inner-wrap">
        <p class="p1" v-if="kr">
          데이터센터 각은 자연에너지를 활용하고 에너지 효율이 높은 설비를 개발해 전기 사용량을 줄임으로써 온실가스
          배출량을 감축하고 있습니다.<br /><br />
          <span>
            &lt;국립산림과학원 발간, 표준탄소 흡수량 기준&gt;<br />
            30년산 소나무의 연간 온실가스 흡수량 : 한 그루당 약 6.6kg<br />
          </span>
        </p>
        <p class="p1" v-else>
          Data Center GAK reduces greenhouse gas emissions by utilizing natural energy and developing energy-efficient
          facilities that reduce power consumption.<br /><br />
          <span>
            &lt;Standard carbon absorption published by the National Institute of Forest Science&gt;<br />
            Annual greenhouse gas absorption by a 30-year-old pine tree: Approximately 6.6 kg per tree
          </span>
        </p>
      </div>
    </section>
    <grid-base grey class="sec3">
      <div class="inner-wrap">
        <h3 v-if="kr"><TextBlock file="green/green-energy-t4" class="pre-line" /></h3>
        <h3 v-else><TextBlock file="green/green-energy-t4" class="pre-line" /></h3>
        <p>
          <template v-if="kr">
            PUE(Power Usage Effectiveness, 전력사용 효율 지수)는 데이터센터의 효율을 나타내는 척도입니다. <br />총
            전력량을 IT 장비가 소비하는 전력량으로 나눈 값으로 1에 가까울수록 전력을 많이 절감한 것입니다.
            <br />데이터센터 각은 전기 사용을 대체할 수 있는 친환경 기술과 세심한 운영으로 평균 PUE 1.1x을 유지하고
            있습니다.
          </template>
          <template v-else>
            PUE is an indicative measure of data center efficiency. It is the total amount of power divided by the
            amount of power consumed by IT equipment. The closer it is to 1, the more power is saved. Data Center GAK's
            average PUE recorded is 1.1, thanks to its meticulous operation and eco-friendly technology replacing
            conventional electricity use.
          </template>
        </p>
      </div>
      <div class="c1">
        <div class="txt-wrap">
          <div class="txt">
            <p>
              <template v-if="kr">전력 효율 지수</template>
              <template v-else>Power Usage Effectiveness</template>
            </p>
            <p>
              <b>1.1<span>x</span></b>
              <s class="calibre">PUE</s>
            </p>
          </div>
        </div>
      </div>
      <div class="graph">
        <p v-if="kr">각 춘천, 각 세종 월별 PUE Trend</p>
        <p v-else>
          Monthly PUE Trend<br />
          GAK Chuncheon & GAK Sejong
        </p>
        <Graph v-if="kr" class="line" :info="energykr" />
        <Graph v-else class="line" :info="energyen" />
        <div class="desc" v-if="kr">
          <p>각 춘천</p>
          <p>각 세종</p>
          <p>Avg.</p>
        </div>
        <div class="desc" v-else>
          <p>GAK Chuncheon</p>
          <p>GAK Sejong</p>
          <p>Avg.</p>
        </div>
      </div>
      <div class="inner-wrap">
        <p>
          <template v-if="kr">
            각 세종은 365일 자연외기를 최대로 활용할 수 있는 하이브리드 공조시스템 NAMU3가 적용되어 한층 더 효율적이고
            안정적인 운영을 하고 있습니다.
          </template>
          <template v-else>
            GAK Sejong is operated more efficiently and stably with the hybrid air conditioning system NAMU3, which can
            maximize the use of natural air all year round
          </template>
        </p>
      </div>
    </grid-base>
    <section class="sec4">
      <div class="inner-wrap">
        <div class="split-view">
          <h3>
            <template v-if="kr">에너지, <br />아껴 쓰고 <br />다시 쓰다.</template>
            <template v-else>Energy, <br />saved and <br />reused</template>
          </h3>
          <div>
            <div class="txt">
              <p>
                <template v-if="kr">온실가스 배출 절감량</template>
                <template v-else>Reduced amount of <br />greenhouse gas emissions</template>
              </p>
              <p v-if="kr"><b class="sm">1.5</b><s>만 톤</s></p>
              <p v-else><b class="sm">15</b><s>thousand tons</s></p>
            </div>
          </div>
        </div>
        <p>
          <template v-if="kr">
            절수용 위생기구를 사용하고 오염이 적은 기화식 가습 장치에서 사용된 물을 냉각수로 재활용하고 있습니다. 빗물
            역시 저장해서 조경,소방 용수 뿐 아니라 설비에 필요한 물로 재활용합니다. 태양광 발전과 외기 도입, 전력 소비를
            절감하는 장치를 갖춤으로써, 온실가스 배출량을 약 1.5만톤 줄였습니다.
          </template>
          <template v-else>
            We use water-saving sanitary equipment, and any water used by the low-pollution vapor humidification
            installation is recycled as coolant. Rainwater is also stored to be recycled as the water for landscaping,
            fire extinguishing, and facilities.<br />Approximately 15,000 tons of greenhouse gas emissions were reduced
            by having solar power facilities, outside air conditioning system, and devices that reduce power
            consumption.
          </template>
        </p>
      </div>
      <slider :option="{ breakpoints: { 768: { slidesPerView: 'auto', centeredSlides: true } } }">
        <img src="/img/esg/energy-slide-1.png" alt="" class="swiper-slide" />
        <img src="/img/esg/energy-slide-2.png" alt="" class="swiper-slide" />
        <img src="/img/esg/energy-slide-3.png" alt="" class="swiper-slide" />
        <img src="/img/esg/energy-slide-4.png" alt="" class="swiper-slide" />
        <img src="/img/esg/energy-slide-5.png" alt="" class="swiper-slide" />
      </slider>
      <div class="graph">
        <p>{{ this.kr ? "태양광 발전량" : "Solar Energy Consumption" }} (MWh)</p>
        <Graph :info="sun" />
        <div class="desc" v-if="kr">
          <p>각 춘천</p>
          <p>각 세종</p>
        </div>
        <div class="desc" v-else>
          <p>GAK Chuncheon</p>
          <p>GAK Sejong</p>
        </div>
      </div>
      <div class="inner-wrap">
        <p>
          <template v-if="kr">
            데이터센터 각은 태양광 발전 시설을 통해 추가 전력을 확보하여 조명 및 일반 동력 사용에 기여하고 있으며, 연간
            약 200MWh의 전력을 절감하고 있습니다.<br />각 세종은 향 후 단계적으로 태양광 발전 시설을 확대 예정입니다.
          </template>
          <template v-else>
            Data Center GAK secures additional power through solar power generation facilities, contributing to lighting
            and general power usage, and achieves annual energy savings of approximately 200 MWh.<br />GAK Sejong
            district plans to gradually expand solar power generation facilities in the coming stages.
          </template>
        </p>
      </div>
      <div class="graph">
        <p>{{ this.kr ? "지열에너지 발전량" : "Geothermal Energy Generation" }} (Gcal)</p>
        <Graph v-if="kr" class="line" :info="earthkr" />
        <Graph v-else class="line" :info="earthen" />
      </div>
      <div class="inner-wrap">
        <p>
          <template v-if="kr">
            데이터센터 각은 연간 약 1,373 Gcal를 생산하여 본관 및 워크스테이의 냉난방에 100% 활용하고 있습니다.
          </template>
          <template v-else>
            Data Center GAK generates approximately 1,373 Gcal of geothermal energy each year, fully powering 100% of
            the heating and cooling for the main building and Workstay.
          </template>
        </p>
      </div>
    </section>
    <!-- <section class="sec5">
      <div class="inner-wrap">
        <h4>LEED PLATINUM</h4>
        <h3 v-if="kr">세계 최고의 <br />친환경 데이터센터</h3>
        <h3 v-else>World-leading <br />Green Data Center</h3>
        <p>
          <template v-if="kr">
            데이터센터 각에는 지속 가능한 미래를 위한 많은 노력과 기술이 담겨 있으며, 이를 인정받아 데이터센터로는 최고 등급인 LEED Platinum을 획득하였습니다.<br> 각춘천:95점(v3) / 각세종:86점(v4)
          </template>
          <template v-else>
            DATA CENTER GAK exhorted all efforts and technologies for the sustainable future. The eco-friendly way of Gak was acknowledged and become the world’s first data center to acquire the LEED platinum, the highest level with the world’s top score (95) for our technical efforts. <br />(LEED -NC Platinum V2009)
          </template>
        </p>
        <div class="img">
          <img src="/img/esg/energy-s5-img.png" alt="" />
        </div>
        <p>
          <template v-if="kr">
            <span>LEED (Leadership in Energy and Environmental Design)</span>는<br /> 건물의 입지 선정부터 설계, 건축, 운영까지 전 과정에서 얼마나 친환경적 노력을 기울였는지를 평가하는 세계적인 친환경 건물 인증 제도입니다.
          </template>
          <template v-else>
            <span>LEED (Leadership in Energy and <br class="hidden-md-up" />Environmental Design)</span><br />International green building certification system that measures the eco-friendliness of buildings from all aspects, including location selection, design, construction, and operation
          </template>
        </p>
      </div>
    </section> -->
    <quick-link>
      <quick-link-item><router-link to="/esg/leed-platinum">LEED Platinum</router-link></quick-link-item>
      <quick-link-item><router-link to="/tech/technology">Technology</router-link></quick-link-item>
    </quick-link>
  </GridBase>
</template>
<script>
import _ from "lodash";
import GridBase from "../../components/GridBase";
import QuickLink from "@/views/components/QuickLink";
import QuickLinkItem from "@/views/components/QuickLinkItem";
import Slider from "@/views/components/Slider";
import Graph from "@/views/components/Graph";
// import Donut from '@/views/components/Donut';
import TextBlock from "@/views/components/TextBlock";
import energyData from "@/data/archive/energy";

export default {
  name: "green-energy",
  components: { TextBlock, Graph, Slider, QuickLinkItem, QuickLink, GridBase },
  data() {
    return {
      greengas: {},
      // water: {},
      energykr: {},
      energyen: {},
      sun: {},
      earthkr: {},
      earthen: {},
      // electricity: null,
      pue: {},
      pue1: "100%",
      pue2: "100%",
      pue3: "100%",
    };
  },
  mounted() {
    this.greengas = _.find(energyData, (row) => row.id === "greengas");
    // this.water = _.find(energyData, (row) => row.id === "water");
    this.energykr = _.find(energyData, (row) => row.id === "energykr");
    this.energyen = _.find(energyData, (row) => row.id === "energyen");
    this.sun = _.find(energyData, (row) => row.id === "sun");
    this.earthkr = _.find(energyData, (row) => row.id === "earthkr");
    this.earthen = _.find(energyData, (row) => row.id === "earthen");
    // this.electricity = _.find(energyData, (row) => row.id === "electricity");
    this.pue = _.find(energyData, (row) => row.id === "pue");
  },
};
</script>
